import Header from './Header';
import { HeaderFooterFlagType } from '@thrivent/thrivent-public-header-footer/feature-management';

// --------------------------------------------------------------------------

export type HeaderProps = {
  inverted?: boolean;
  hideLoginButton?: boolean;
  hideFAButton?: boolean;
  showHeaderRedesign?: boolean;
  insuranceNavUpdates?: boolean;
  investmentNavUpdates?: boolean;
};

export type HeaderPropsWithFlags = HeaderProps & {
  flags: HeaderFooterFlagType;
};

// --------------------------------------------------------------------------

export const FlaggedHeader = ({
  flags,
  inverted,
  hideLoginButton,
  hideFAButton,
  showHeaderRedesign,
  insuranceNavUpdates,
  investmentNavUpdates,
}: HeaderPropsWithFlags) => {
  // If we pass a prop, just use that, otherwise use the flag value to determine
  const determinedInsuranceNavUpdates =
    insuranceNavUpdates === undefined
      ? flags?.['activate-insurance-nav-updates']
      : insuranceNavUpdates;
  const determinedInvestmentNavUpdates =
    investmentNavUpdates === undefined
      ? flags?.['activate-investment-nav-updates']
      : investmentNavUpdates;

  return (
    <Header
      // These props are "at will"
      inverted={inverted}
      hideLoginButton={hideLoginButton}
      hideFAButton={hideFAButton}
      // This prop DOES have flags associated, but we can't really "force" people onto the brand refresh
      showHeaderRedesign={showHeaderRedesign}
      // These props have flags associated
      insuranceNavUpdates={determinedInsuranceNavUpdates}
      investmentNavUpdates={determinedInvestmentNavUpdates}
    />
  );
};
